import React from "react"
import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"
import { Button } from "@/components/ui/button"
import { SquarePen, Upload } from "lucide-react"
interface SiteHeaderProps {
  title?: string
  showNewChatButton?: boolean
  showUploadButton?: boolean
  onUploadClick?: () => void
  breadcrumb?: React.ReactNode
  headerActions?: React.ReactNode
}

export function SiteHeader({ 
  title = "Аналитика", 
  showNewChatButton = false, 
  showUploadButton = false,
  onUploadClick,
  breadcrumb,
  headerActions,
}: SiteHeaderProps) {
  return (
    <header className="sticky top-0 z-20 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/100 flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        {breadcrumb ? (
          <div className="min-w-0 flex-1 overflow-hidden">
            {breadcrumb}
          </div>
        ) : (
          <h1 className="text-base font-medium flex-1">{title}</h1>
        )}
        {headerActions && (
          <div className="ml-auto flex items-center">
            {headerActions}
          </div>
        )}
        {showNewChatButton && (
          <div className="ml-auto">
            <Button
              variant="ghost"
              size="sm"
              className="h-8 gap-1.5 px-2 cursor-pointer text-sm text-muted-foreground hover:text-foreground"
              onClick={() => {
                try {
                  window.dispatchEvent(new CustomEvent('casper:new-chat'))
                } catch {}
              }}
            >
              <SquarePen className="h-4 w-4" />
              <span>Новый чат</span>
            </Button>
          </div>
        )}
        {showUploadButton && (
          <div className="ml-auto">
            <Button
              variant="ghost"
              size="sm"
              className="h-8 gap-1.5 px-2 cursor-pointer text-sm text-muted-foreground hover:text-foreground"
              onClick={onUploadClick}
            >
              <Upload className="h-4 w-4" />
              <span>Загрузить</span>
            </Button>
          </div>
        )}
      </div>
    </header>
  )
}
